import { Component, Input } from '@angular/core';

export interface CancelledContract {
  id: number;
  cancelled_at: string;
  contract_number: string;
  created_at: string;
  created_by_id: number;
  creator: {
    id: number;
    first_name: string;
    last_name: string;
    third_party?: {
      id: number;
      name: string;
      owner_id: number;
    };
    customer: any[];
  }
  
}

@Component({
  selector: 'app-cancelled-contracts-list',
  templateUrl: './cancelled-contracts-list.component.html',
  styleUrls: ['./cancelled-contracts-list.component.scss']
})
export class CancelledContractsListComponent {
  @Input() contracts: CancelledContract[] = [];
  


}
